module.exports = __webpack_public_path__ + "static/media/16UNODC22.8d314088.jpg";